import { createFileRoute, Link, notFound } from "@tanstack/react-router";
import { z } from "zod";
import { Button } from "@/components/ui/button";
import { sharedRoadmapQuery } from "@/features/roadmap/queries";
import { SharedRoadmapView } from "@/features/roadmap/SharedRoadmapView";
import { ApiError } from "@/lib/api";

const searchSchema = z.object({
  zoom: z.number().int().min(1).optional().catch(undefined),
  /** Comma-separated phase names hidden on the timeline (see lib/phases.ts). */
  hide: z
    .union([z.string(), z.number(), z.boolean()])
    .transform(String)
    .optional()
    .catch(undefined),
});

/** Public, read-only view of a roadmap through its share token. No session needed. */
export const Route = createFileRoute("/s/$token")({
  validateSearch: (search) => searchSchema.parse(search),
  loader: async ({ context, params }) => {
    try {
      await context.queryClient.ensureQueryData(sharedRoadmapQuery(params.token));
    } catch (err) {
      if (err instanceof ApiError && err.status === 404) throw notFound();
      throw err;
    }
  },
  notFoundComponent: () => (
    <div className="flex h-full flex-col items-center justify-center gap-3 text-center">
      <p className="text-lg font-medium">This link is no longer active</p>
      <p className="max-w-sm text-sm text-muted-foreground">
        The owner turned sharing off or the roadmap was deleted. Ask them for a new link.
      </p>
      <Button asChild variant="outline">
        <Link to="/">Go to the app</Link>
      </Button>
    </div>
  ),
  component: () => {
    const { token } = Route.useParams();
    const search = Route.useSearch();
    return <SharedRoadmapView key={token} token={token} search={search} />;
  },
});
